import SegmentGenerator from "@/components/segment-generator";
import SegmentContainer from "./segments/segment-container";
import CallToActionButton from "@/components/call-to-action-button";
import Head from "next/head";
import Layout from "@/components/layout";
import classNames from "classnames";
import ratingSchema from "@/components/rating-schema-jsonld";
import DutiesTaxesSegment from "./duties-taxes-segment";

export default function CountryPageGeneric({
  pageContent,
  preview,
  isoCode,
  rates,
  countryName,
}) {
  const heroBanner = pageContent.segments[0];
  const otherSegments = pageContent.segments.slice(1);

  const replaceCountry = (text) => {
    return text.replaceAll("{country}", countryName);
  };

  pageContent.segments.forEach((segment) => {
    segment.blocks?.forEach((block) => {
      block.heading.forEach((heading) => {
        heading.children.forEach((item) => {
          item.text = replaceCountry(item.text);
        });
      });
      block.content.forEach((content) => {
        content.children.forEach((item) => {
          item.text = replaceCountry(item.text);
        });
      });
    });
    segment.block?.heading?.forEach((heading) => {
      heading.children.forEach((item) => {
        item.text = replaceCountry(item.text);
      });
    });
    segment.block?.content?.forEach((content) => {
      content.children.forEach((item) => {
        item.text = replaceCountry(item.text);
      });
    });
  });

  return (
    <Layout preview={preview}>
      <Head>
        <title>{replaceCountry(pageContent.title)}</title>
        <meta
          name="description"
          content={replaceCountry(pageContent.metaDescription)}
        />
        <meta property="og:title" content={replaceCountry(pageContent.title)} />
        <meta
          property="og:description"
          content={replaceCountry(pageContent.metaDescription)}
        />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_HOST}/${pageContent.slug.current}`}
        />
        <meta property="og:type" content="article" />
        <meta
          property="article:modified_time"
          content={pageContent._updatedAt}
        ></meta>
        <meta property="og:site_name" content="JustShip" />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:site_name"
          content={replaceCountry(pageContent.title)}
        ></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Est. reading time" />
        <meta name="twitter:data1" content="3 minutes" />
        {ratingSchema()}
      </Head>
      <div className="bg-background-dark-gray">
        <SegmentGenerator key={heroBanner._id} segment={heroBanner} />
        <SegmentContainer className="py-8 md:py-14 h-full">
          <div
            className={classNames(
              "flex flex-col justify-center items-center md:items-start",
              "md:grid grid-cols-2 mx-auto"
            )}
          >
            <div className="text-center md:text-left mb-6 md:mb-0">
              <h2 className="text-xl md:text-2xl font-medium whitespace-pre-line">
                Get The Best Shipping Rates{"\n"}To{" "}
                <span className="font-bold italic">{countryName}</span>
              </h2>
              <CallToActionButton
                className="mt-8 hidden w-52 md:block leading-tight"
                href="/create-shipment"
              >
                Ship Now
              </CallToActionButton>
            </div>
            <div className="md:pl-8">
              <table
                className={classNames(
                  "border-collapse border-y border-y-light-purple",
                  "text-sm sm:text-base w-full table-fixed md:table-auto"
                )}
              >
                <thead className="text-left align-top">
                  <tr className="text-center md:text-left">
                    <th className="py-2 px-2 md:px-4">
                      <p>Weight</p>
                    </th>
                    <th className="py-2 px-2 md:px-4">
                      <p>Price</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rates.map(({ weight, price }) => {
                    return (
                      <tr
                        key={weight}
                        className={classNames(
                          "border-y border-y-light-purple text-sm md:text-base",
                          "text-center md:text-left"
                        )}
                      >
                        <td className="py-2 px-2 md:px-4">
                          <p className="pr-2 md:pr-0">{weight} kg</p>
                        </td>
                        <td className="py-2 px-2 md:px-4">
                          <p className="md:whitespace-nowrap">${price}</p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <CallToActionButton
                className="mt-8 md:hidden w-full leading-tight"
                href="/create-shipment"
              >
                Ship Now
              </CallToActionButton>
            </div>
          </div>
        </SegmentContainer>
        <DutiesTaxesSegment isoCode={isoCode} countryName={countryName} />
        {otherSegments.map((segment) => (
          <SegmentGenerator key={segment._id} segment={segment} />
        ))}
      </div>
    </Layout>
  );
}
